<template>
   <content-loader
    view-box="0 0 300 350"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
    height="320"
    style=""
  >
    <rect x="8" y="249" rx="3" ry="3" width="383" height="18" /> 
    <rect x="8" y="36" rx="3" ry="3" width="383" height="18" /> 
    <rect x="8" y="63" rx="3" ry="3" width="383" height="18" /> 
    <rect x="8" y="90" rx="3" ry="3" width="383" height="18" /> 
    <rect x="8" y="117" rx="3" ry="3" width="383" height="18" /> 
    <rect x="8" y="143" rx="3" ry="3" width="383" height="18" /> 
    <rect x="8" y="170" rx="3" ry="3" width="383" height="18" /> 
    <rect x="8" y="223" rx="3" ry="3" width="383" height="18" /> 
    <rect x="8" y="197" rx="3" ry="3" width="383" height="18" /> 
    <rect x="6" y="15" rx="0" ry="0" width="120" height="8" /> 
    <rect x="0" y="8" rx="0" ry="0" width="1" height="267" /> 
    <rect x="0" y="274" rx="0" ry="0" width="398" height="1" /> 
    <rect x="397" y="8" rx="0" ry="0" width="1" height="267" /> 
    <rect x="0" y="8" rx="0" ry="0" width="398" height="1" /> 
    <rect x="0" y="286" rx="0" ry="0" width="70" height="20" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "FormInput12WithTitle",
    components: { ContentLoader },
};
</script>